import type { Store } from "redux";
import { bindActionCreators } from "redux";
import { endLoading, restoreLogin, startLoading } from "~/actions/PreAuthActions/preAuthActions";
import { useAuthStore } from "~/store/auth/useAuthStore";
import { useThemeStore } from "~/store/theme/useThemeStore";
import type ReduxStateType from "../../reducers/ReduxStateType";
import Root from "./Root";

interface RootContainerProps {
    store: Store<ReduxStateType>;
}

const RootContainer = ({ store }: RootContainerProps) => {
    const isAuthenticated = useAuthStore(s => s.isAuthenticated);
    const setIsAuthenticated = useAuthStore(s => s.setIsAuthenticated);
    const setDarkMode = useThemeStore(s => s.setDarkMode);

    const boundActions = bindActionCreators({ restoreLogin, startLoading, endLoading }, store.dispatch);

    const actions = {
        setIsAuthenticated,
        restoreLogin: boundActions.restoreLogin,
        startLoading: boundActions.startLoading,
        endLoading: boundActions.endLoading,
        setDarkMode,
    };

    return <Root store={store} actions={actions} isAuthenticated={isAuthenticated} />;
};

export default RootContainer;
